import { useLocation, useNavigate } from 'react-router-dom';

import { PyButton } from '../../../components';
import { usePayLinkCart } from '../context/PayLinkCartContext';
import { usePayLinkUser } from '../context/PaylinkUserContext';

export const MerchantHeader = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { storeProfile, cartCount } = usePayLinkCart();
  const { user } = usePayLinkUser();

  const userEmail = user?.email ?? "";
  const userInitials = userEmail
    ? userEmail.slice(0, 2).toUpperCase()
    : "";
  const truncatedEmail =
    userEmail.length > 20
      ? `${userEmail.slice(0, 8)}...${userEmail.slice(userEmail.lastIndexOf("@"))}`
      : userEmail;

  const storeSlug = storeProfile?.slug;
  const storeName = storeProfile?.storeName || "Store";
  const storeImageUrl = storeProfile?.storeImageUrl || "";
  const storeInitials =
    storeName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0]?.toUpperCase())
      .join("") || "ST";

  const hasStoreLink = !!storeSlug;
  const storeLink = hasStoreLink ? `/paylink/s/${storeSlug}` : null;
  const isPayLinkCartRoute = ["/paylink/checkout", "/paylink/session"].includes(pathname);

  const handleStoreClick = () => {
    if (!storeLink) return;
    navigate(storeLink);
  };

  return (
    <header className="!p-5 flex items-center justify-between">
      <div
        onClick={handleStoreClick}
        className={`inline-flex items-center !gap-2 lg:!gap-4 ${
          hasStoreLink ? "cursor-pointer" : "cursor-default"
        }`}
      >
        <div className="min-w-10 lg:min-w-14 h-10 lg:h-14 rounded-full inline-flex justify-center items-center bg-py_blue-50 text-py_blue-700 text-base font-medium leading-[140%] tracking-[-0.02em] overflow-hidden">
          {storeImageUrl ? (
            <img
              src={storeImageUrl}
              alt={storeName}
              className="w-full h-full object-cover"
            />
          ) : (
            storeInitials
          )}
        </div>
        <h4 className="text-base lg:text-lg text-py_black-950 font-medium leading-[140%] tracking-[-0.02em]">
          {storeName}
        </h4>
      </div>

      <div className="flex items-center gap-3">
        {!isPayLinkCartRoute && (
          <>
            {cartCount > 0 && (
              <PyButton
                link="/paylink/session"
                extraClass="!bg-py_green_2-600 !border-py_green_2-600 !text-[0.875rem] !px-3 !h-8"
              >
                View cart ({cartCount})
              </PyButton>
            )}
          </>
        )}

        {userEmail && (
          <div className="flex items-center gap-2">
            <div className="min-w-8 h-8 rounded-full inline-flex justify-center items-center bg-py_blue-700 text-white text-xs font-semibold select-none">
              {userInitials}
            </div>
            <span className="hidden sm:block text-xs text-py_black_600 max-w-[140px] truncate">
              {truncatedEmail}
            </span>
          </div>
        )}
      </div>
      {/* : (
        <PyButton
          link={storeLink}
          extraClass="!bg-py_green_2-600 !border-py_green_2-600 !text-[0.875rem] !px-3 !h-8"
        >
          Browse products
        </PyButton>
      )} */}
    </header>
  );
};
